<div class="accessibility-settings-card">
  @if(isLoading()) {
    <div class="loading-container">
      <app-loading-animation></app-loading-animation>
      <p>Loading accessibility content...</p>
    </div>
  } @else {
    <!-- Toggle Section -->
    <div class="toggle-section">
      <div class="toggle-row">
        <span class="toggle-label">Accessibility</span>
        <label class="switch"  for="accessibilityToggle">
          <input 
            id="accessibilityToggle"
            type="checkbox" 
            aria-label="Accessibility"
            [checked]="isAccessibilityEnabled()" 
            [disabled]="isUpdatingStatus()"
            (change)="toggleAccessibilityStatus()"
          />
          <span class="slider round"></span>
        </label>
      </div>
      
      @if(!isAccessibilityEnabled()) {
        <div class="warning-message">
          Accessibility is currently disabled. Users will not see accessibility information when accessing the portal.
        </div>
      }
      
      @if(statusMessage()) {
        <div class="status-message" [class.error]="statusMessage().includes('Error')">
          {{ statusMessage() }}
        </div>
      }
    </div>

    <div class="divider"></div>

    <!-- Content Section -->
    <div class="content-section">
      <label for="accessibilityContent" class="content-label">
        @if(!isAccessibilityEnabled()) {
          <span class="disabled-hint">(Enable to edit)</span>
        }
      </label>
      
      <textarea 
        id="accessibilityContent"
        class="accessibility-textarea"
        [(ngModel)]="accessibilityContent"
        (input)="onAccessibilityContentChange()"
        [disabled]="!isAccessibilityEnabled()"
        placeholder="Accessibility"
        rows="10">
      </textarea>
      
      <div class="help-text">
        <div><strong>Supported HTML:</strong> h1-h6, p, div, span, strong, em, ul, ol, li, a, br</div>
        <div><strong>Security:</strong> Scripts, iframes, and event handlers are automatically removed</div>
      </div>

      @if(securityWarning()) {
        <div class="security-warning">
          {{ securityWarning() }}
        </div>
      }
    </div>

    <!-- Actions -->
    <div class="actions-section">
      <button 
        type="button" 
        class="btn-secondary"
        [disabled]="!hasUnsavedChanges() || isSaving() || !isAccessibilityEnabled()"
        (click)="discardChanges()">
        Discard Changes
      </button>
      <button 
        type="button" 
        class="btn-primary"
        [disabled]="isSaving() || !isAccessibilityEnabled()"
        (click)="saveAccessibilityContent()">
        @if (!isSaving()) {
        <span>Save Accessibility</span>
        } @else {
        <span>Saving...</span>
        }
      </button>
    </div>

    @if(saveMessage()) {
      <div class="save-message" [class.success]="!saveMessage().includes('Error')" [class.error]="saveMessage().includes('Error')">
        {{ saveMessage() }}
      </div>
    }
  }
</div>
